import { create } from "zustand"

/**
 * Bridges the globally-rendered error banner (mounted in AppShell) to the
 * active workspace's retry action. The OIO workspace registers a handler that
 * re-runs draft generation; the FatalErrorBanner's Retry invokes it.
 */
interface RetryState {
  handler: (() => void) | null
  setHandler: (h: (() => void) | null) => void
}

export const useRetryStore = create<RetryState>((set) => ({
  handler: null,
  setHandler: (handler) => set({ handler }),
}))
